import { createFileRoute } from '@tanstack/react-router';

import { EventsPage } from '@/pages/utils/EventsPage.tsx';

export const Route = createFileRoute('/(app)/utils/eventStream')({
  component: EventsPage,
});
